"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AccountService_1 = require("./services/AccountService");
const AuthService_1 = require("./services/AuthService");
const GeneralService_1 = require("./services/GeneralService");
const PaymentService_1 = require("./services/PaymentService");
const KevinApiClient_1 = require("./client/KevinApiClient");
class Client {
    constructor(clientId, clientSecret, clientOptions) {
        this._account = undefined;
        this._auth = undefined;
        this._general = undefined;
        this._payment = undefined;
        this._client = new KevinApiClient_1.default(clientId, clientSecret, clientOptions);
    }
    get account() {
        if (typeof this._account === 'undefined') {
            this._account = new AccountService_1.default(this._client);
        }
        return this._account;
    }
    get auth() {
        if (typeof this._auth === 'undefined') {
            this._auth = new AuthService_1.default(this._client);
        }
        return this._auth;
    }
    get general() {
        if (typeof this._general === 'undefined') {
            this._general = new GeneralService_1.default(this._client);
        }
        return this._general;
    }
    get payment() {
        if (typeof this._payment === 'undefined') {
            this._payment = new PaymentService_1.default(this._client);
        }
        return this._payment;
    }
}
exports.default = Client;
